<template>
  <v-expansion-panels
    multiple
    v-model="panelsAbertos"
    class="formulario-pre-contratacao"
    :class="{ 'formulario-pre-contratacao--publico': obrigatorio }"
    :style="{ '--mensagem-campo-pendente': mensagemCampoPendente }"
  >
    <v-expansion-panel v-show="secaoVisivel('Identificacao')">
      <v-expansion-panel-header>
        <span class="secao-cabecalho">
          <span>{{ $t("Identificacao") }}</span>
          <span
            v-if="statusSecoes.Identificacao"
            class="secao-status"
            :class="statusSecoes.Identificacao.classe"
          >
            {{ statusSecoes.Identificacao.texto }}
          </span>
        </span>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="6"
            v-if="isVisivel('nomeSocial')"
            data-campo="nomeSocial"
            :class="classeCampo('nomeSocial')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('nomeSocial')"
            >
              {{ $t("Nome_social") }}
            </span>
            <v-text-field
              v-model="recurso.nomeSocial"
              :label="$t('Nome_social')"
              name="nomeSocial"
              :obrigatorio="isObrigatorio('nomeSocial')"
              autocomplete="name"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('cpf')"
            data-campo="cpf"
            :class="classeCampo('cpf')"
          >
            <span class="opacity-5 text-dark" :class="classeRotulo('cpf')">
              {{ $t("CPF") }}
            </span>
            <v-text-field
              v-model="recurso.cpf"
              :label="$t('CPF')"
              name="cpf"
              v-mask="'###.###.###-##'"
              :obrigatorio="isObrigatorio('cpf')"
              inputmode="numeric"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('email')"
            data-campo="email"
            :class="classeCampo('email')"
          >
            <span class="opacity-5 text-dark" :class="classeRotulo('email')">
              {{ $t("Email") }}
            </span>
            <v-text-field
              v-model="recurso.email"
              :label="$t('Email')"
              name="email"
              :obrigatorio="isObrigatorio('email')"
              type="email"
              inputmode="email"
              autocomplete="email"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('telefone')"
            data-campo="telefone"
            :class="classeCampo('telefone')"
          >
            <span class="opacity-5 text-dark" :class="classeRotulo('telefone')">
              {{ $t("Telefone") }}
            </span>
            <v-text-field
              v-model="recurso.telefone"
              :label="$t('Telefone')"
              name="telefone"
              :obrigatorio="isObrigatorio('telefone')"
              type="tel"
              inputmode="tel"
              autocomplete="tel"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            id="campo-dt-nascimento"
            v-if="isVisivel('dtNascimento')"
            data-campo="dtNascimento"
            :class="classeCampo('dtNascimento')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('dtNascimento')"
            >
              {{ $t("Data_de_nascimento") }}
            </span>
            <CampoData
              @date="recurso.dtNascimento = $event"
              :payload="recurso.dtNascimento"
              label="Data_de_nascimento"
              :obrigatorio="isObrigatorio('dtNascimento')"
            />
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('sexo')"
            data-campo="sexo"
            :class="classeCampo('sexo')"
          >
            <span class="opacity-5 text-dark" :class="classeRotulo('sexo')">
              {{ $t("Sexo") }}
            </span>
            <v-select
              :items="itensSexo"
              :label="$t('Sexo')"
              v-model="recurso.sexo"
              :obrigatorio="isObrigatorio('sexo')"
              solo
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
            ></v-select>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('naturalidade')"
            data-campo="naturalidade"
            :class="classeCampo('naturalidade')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('naturalidade')"
            >
              {{ $t("Naturalidade") }}
            </span>
            <v-autocomplete
              :items="cidades"
              :item-text="
                (item) =>
                  item.nome +
                  (item.estado && item.estado.sigla
                    ? '/' + item.estado.sigla
                    : '')
              "
              return-object
              :label="$t('Naturalidade')"
              v-model="recurso.naturalidade"
              :obrigatorio="isObrigatorio('naturalidade')"
              solo
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
            >
            </v-autocomplete>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('instrucao')"
            data-campo="instrucao"
            :class="classeCampo('instrucao')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('instrucao')"
            >
              {{ $t("Instrucao") }}
            </span>
            <v-select
              :items="itensInstrucao"
              :label="$t('Instrucao')"
              v-model="recurso.instrucao"
              :obrigatorio="isObrigatorio('instrucao')"
              solo
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
            ></v-select>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('raca')"
            data-campo="raca"
            :class="classeCampo('raca')"
          >
            <span class="opacity-5 text-dark" :class="classeRotulo('raca')">
              {{ $t("Raca") }}
            </span>
            <v-select
              :items="itensRaca"
              :label="$t('Raca')"
              v-model="recurso.raca"
              :obrigatorio="isObrigatorio('raca')"
              solo
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
            ></v-select>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('estadoCivil')"
            data-campo="estadoCivil"
            :class="classeCampo('estadoCivil')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('estadoCivil')"
            >
              {{ $t("Estado_civil") }}
            </span>
            <v-autocomplete
              :items="itensEstadoCivil"
              item-text="text"
              item-value="value"
              :label="$t('Estado_civil')"
              v-model="recurso.estadoCivil"
              :obrigatorio="isObrigatorio('estadoCivil')"
              solo
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
            >
            </v-autocomplete>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('grupoSanguineo')"
            data-campo="grupoSanguineo"
            :class="classeCampo('grupoSanguineo')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('grupoSanguineo')"
            >
              {{ $t("Grupo_sanguineo") }}
            </span>
            <v-select
              :items="itensGrupoSanguineo"
              :label="$t('Grupo_sanguineo')"
              v-model="recurso.grupoSanguineo"
              :obrigatorio="isObrigatorio('grupoSanguineo')"
              solo
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
            ></v-select>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel v-show="secaoVisivel('Endereco')">
      <v-expansion-panel-header>
        <span class="secao-cabecalho">
          <span>{{ $t("Endereco") }}</span>
          <span
            v-if="statusSecoes.Endereco"
            class="secao-status"
            :class="statusSecoes.Endereco.classe"
          >
            {{ statusSecoes.Endereco.texto }}
          </span>
        </span>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('cep')"
            data-campo="cep"
            :class="classeCampo('cep')"
          >
            <span class="opacity-5 text-dark" :class="classeRotulo('cep')">
              {{ $t("Cep") }}
            </span>
            <v-text-field
              v-model="recurso.cep"
              :label="$t('Cep')"
              name="cep"
              v-mask="'##.###-###'"
              :loading="loadingCep"
              @blur="buscaCep"
              :obrigatorio="isObrigatorio('cep')"
              inputmode="numeric"
              autocomplete="postal-code"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="12"
            md="6"
            v-if="isVisivel('logradouro')"
            data-campo="logradouro"
            :class="classeCampo('logradouro')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('logradouro')"
            >
              {{ $t("Logradouro") }}
            </span>
            <v-text-field
              v-model="recurso.logradouro"
              :label="$t('Logradouro')"
              name="logradouro"
              :obrigatorio="isObrigatorio('logradouro')"
              autocomplete="address-line1"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('numero')"
            data-campo="numero"
            :class="classeCampo('numero')"
          >
            <span class="opacity-5 text-dark" :class="classeRotulo('numero')">
              {{ $t("Numero") }}
            </span>
            <v-text-field
              v-model="recurso.numero"
              :label="$t('Numero')"
              name="numero"
              :obrigatorio="isObrigatorio('numero')"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="4"
            v-if="isVisivel('complemento')"
            data-campo="complemento"
            :class="classeCampo('complemento')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('complemento')"
            >
              {{ $t("Complemento") }}
            </span>
            <v-text-field
              v-model="recurso.complemento"
              :label="$t('Complemento')"
              name="complemento"
              :obrigatorio="isObrigatorio('complemento')"
              autocomplete="address-line2"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="4"
            v-if="isVisivel('bairro')"
            data-campo="bairro"
            :class="classeCampo('bairro')"
          >
            <span class="opacity-5 text-dark" :class="classeRotulo('bairro')">
              {{ $t("Bairro") }}
            </span>
            <v-text-field
              v-model="recurso.bairro"
              :label="$t('Bairro')"
              name="bairro"
              :obrigatorio="isObrigatorio('bairro')"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="2"
            v-if="isVisivel('uf')"
            data-campo="uf"
            :class="classeCampo('uf')"
          >
            <span class="opacity-5 text-dark" :class="classeRotulo('uf')">
              {{ $t("UF") }}
            </span>
            <v-select
              :items="estados"
              item-text="sigla"
              item-value="sigla"
              :label="$t('UF')"
              v-model="recurso.uf"
              :obrigatorio="isObrigatorio('uf')"
              solo
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
            ></v-select>
          </v-col>

          <v-col
            cols="12"
            sm="12"
            md="6"
            v-if="isVisivel('cidade')"
            data-campo="cidade"
            :class="classeCampo('cidade')"
          >
            <span class="opacity-5 text-dark" :class="classeRotulo('cidade')">
              {{ $t("Cidade") }}
            </span>
            <v-autocomplete
              :items="cidades"
              :item-text="
                (item) =>
                  item.nome +
                  (item.estado && item.estado.sigla
                    ? '/' + item.estado.sigla
                    : '')
              "
              return-object
              :label="$t('Cidade')"
              v-model="recurso.cidade"
              :obrigatorio="isObrigatorio('cidade')"
              solo
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              @change="handleCidadeChange"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel v-show="secaoVisivel('Documentos')">
      <v-expansion-panel-header>
        <span class="secao-cabecalho">
          <span>{{ $t("Documentos") }}</span>
          <span
            v-if="statusSecoes.Documentos"
            class="secao-status"
            :class="statusSecoes.Documentos.classe"
          >
            {{ statusSecoes.Documentos.texto }}
          </span>
        </span>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('pis')"
            data-campo="pis"
            :class="classeCampo('pis')"
          >
            <span class="opacity-5 text-dark" :class="classeRotulo('pis')">
              {{ $t("PIS") }}
            </span>
            <v-text-field
              v-model="recurso.pis"
              :label="$t('PIS')"
              name="pis"
              :obrigatorio="isObrigatorio('pis')"
              inputmode="numeric"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('rg')"
            data-campo="rg"
            :class="classeCampo('rg')"
          >
            <span class="opacity-5 text-dark" :class="classeRotulo('rg')">
              {{ $t("RG") }}
            </span>
            <v-text-field
              v-model="recurso.rg"
              :label="$t('RG')"
              name="rg"
              :obrigatorio="isObrigatorio('rg')"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('rgExpedicao')"
            data-campo="rgExpedicao"
            :class="classeCampo('rgExpedicao')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('rgExpedicao')"
            >
              {{ $t("Expedicao_rg") }}
            </span>
            <CampoData
              @date="recurso.rgExpedicao = $event"
              :payload="recurso.rgExpedicao"
              label="Expedicao_rg"
              :obrigatorio="isObrigatorio('rgExpedicao')"
            />
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('rgUF')"
            data-campo="rgUF"
            :class="classeCampo('rgUF')"
          >
            <span class="opacity-5 text-dark" :class="classeRotulo('rgUF')">
              {{ $t("Uf_expedicao_rg") }}
            </span>
            <v-autocomplete
              :items="estados"
              item-text="nome"
              return-object
              :label="$t('Uf_expedicao_rg')"
              v-model="recurso.rgUF"
              :obrigatorio="isObrigatorio('rgUF')"
              solo
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
            >
            </v-autocomplete>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('cnh')"
            data-campo="cnh"
            :class="classeCampo('cnh')"
          >
            <span class="opacity-5 text-dark" :class="classeRotulo('cnh')">
              {{ $t("CNH") }}
            </span>
            <v-text-field
              v-model="recurso.cnh"
              :label="$t('CNH')"
              name="cnh"
              :obrigatorio="isObrigatorio('cnh')"
              inputmode="numeric"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('cnhCategoria')"
            data-campo="cnhCategoria"
            :class="classeCampo('cnhCategoria')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('cnhCategoria')"
            >
              {{ $t("Categoria_cnh") }}
            </span>
            <v-select
              :items="itensCnhCategoria"
              :label="$t('Categoria_cnh')"
              v-model="recurso.cnhCategoria"
              name="cnhCategoria"
              :obrigatorio="isObrigatorio('cnhCategoria')"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-select>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('cnhUF')"
            data-campo="cnhUF"
            :class="classeCampo('cnhUF')"
          >
            <span class="opacity-5 text-dark" :class="classeRotulo('cnhUF')">
              {{ $t("Uf_cnh") }}
            </span>
            <v-autocomplete
              :items="estados"
              item-text="nome"
              return-object
              :label="$t('Uf_cnh')"
              v-model="recurso.cnhUF"
              name="cnhUF"
              :obrigatorio="isObrigatorio('cnhUF')"
              solo
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
            >
            </v-autocomplete>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('cnhValidade')"
            data-campo="cnhValidade"
            :class="classeCampo('cnhValidade')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('cnhValidade')"
            >
              {{ $t("Cnh_validade") }}
            </span>
            <CampoData
              @date="recurso.cnhValidade = $event"
              :payload="recurso.cnhValidade"
              label="Cnh_validade"
              :obrigatorio="isObrigatorio('cnhValidade')"
            />
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('cnhEmissao')"
            data-campo="cnhEmissao"
            :class="classeCampo('cnhEmissao')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('cnhEmissao')"
            >
              {{ $t("Cnh_emissao") }}
            </span>
            <CampoData
              @date="recurso.cnhEmissao = $event"
              :payload="recurso.cnhEmissao"
              label="Cnh_emissao"
              :obrigatorio="isObrigatorio('cnhEmissao')"
            />
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('ctpsNumero')"
            data-campo="ctpsNumero"
            :class="classeCampo('ctpsNumero')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('ctpsNumero')"
            >
              {{ $t("Numero_ctps") }}
            </span>
            <v-text-field
              v-model="recurso.ctpsNumero"
              :label="$t('Numero_ctps')"
              name="ctpsNumero"
              :obrigatorio="isObrigatorio('ctpsNumero')"
              inputmode="numeric"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('ctpsSerie')"
            data-campo="ctpsSerie"
            :class="classeCampo('ctpsSerie')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('ctpsSerie')"
            >
              {{ $t("Serie_ctps") }}
            </span>
            <v-text-field
              v-model="recurso.ctpsSerie"
              :label="$t('Serie_ctps')"
              name="ctpsSerie"
              :obrigatorio="isObrigatorio('ctpsSerie')"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('ctpsUF')"
            data-campo="ctpsUF"
            :class="classeCampo('ctpsUF')"
          >
            <span class="opacity-5 text-dark" :class="classeRotulo('ctpsUF')">
              {{ $t("Ctps_uf") }}
            </span>
            <v-autocomplete
              :items="estados"
              item-text="nome"
              return-object
              :label="$t('Ctps_uf')"
              v-model="recurso.ctpsUF"
              :obrigatorio="isObrigatorio('ctpsUF')"
              solo
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
            >
            </v-autocomplete>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('reservistaCategoria')"
            data-campo="reservistaCategoria"
            :class="classeCampo('reservistaCategoria')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('reservistaCategoria')"
            >
              {{ $t("Categoria_reservista") }}
            </span>
            <v-text-field
              v-model="recurso.reservistaCategoria"
              :label="$t('Categoria_reservista')"
              name="reservistaCategoria"
              :obrigatorio="isObrigatorio('reservistaCategoria')"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('reservistaNumero')"
            data-campo="reservistaNumero"
            :class="classeCampo('reservistaNumero')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('reservistaNumero')"
            >
              {{ $t("Numero_reservista") }}
            </span>
            <v-text-field
              v-model="recurso.reservistaNumero"
              :label="$t('Numero_reservista')"
              name="reservistaNumero"
              :obrigatorio="isObrigatorio('reservistaNumero')"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('tituloEleitoral')"
            data-campo="tituloEleitoral"
            :class="classeCampo('tituloEleitoral')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('tituloEleitoral')"
            >
              {{ $t("tituloEleitoral") }}
            </span>
            <v-text-field
              v-model="recurso.tituloEleitoral"
              :label="$t('tituloEleitoral')"
              name="tituloEleitoral"
              :obrigatorio="isObrigatorio('tituloEleitoral')"
              inputmode="numeric"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('tituloEleitoralZona')"
            data-campo="tituloEleitoralZona"
            :class="classeCampo('tituloEleitoralZona')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('tituloEleitoralZona')"
            >
              {{ $t("tituloEleitoralZona") }}
            </span>
            <v-text-field
              v-model="recurso.tituloEleitoralZona"
              :label="$t('tituloEleitoralZona')"
              name="tituloEleitoralZona"
              :obrigatorio="isObrigatorio('tituloEleitoralZona')"
              inputmode="numeric"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('tituloEleitoralSecao')"
            data-campo="tituloEleitoralSecao"
            :class="classeCampo('tituloEleitoralSecao')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('tituloEleitoralSecao')"
            >
              {{ $t("tituloEleitoralSecao") }}
            </span>
            <v-text-field
              v-model="recurso.tituloEleitoralSecao"
              :label="$t('tituloEleitoralSecao')"
              name="tituloEleitoralSecao"
              :obrigatorio="isObrigatorio('tituloEleitoralSecao')"
              inputmode="numeric"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-text-field>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel v-show="secaoVisivel('Dados_familiares')">
      <v-expansion-panel-header>
        <span class="secao-cabecalho">
          <span>{{ $t("Dados_familiares") }}</span>
          <span
            v-if="statusSecoes.Dados_familiares"
            class="secao-status"
            :class="statusSecoes.Dados_familiares.classe"
          >
            {{ statusSecoes.Dados_familiares.texto }}
          </span>
        </span>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="4"
            v-if="isVisivel('nomePai')"
            data-campo="nomePai"
            :class="classeCampo('nomePai')"
          >
            <span class="opacity-5 text-dark" :class="classeRotulo('nomePai')">
              {{ $t("Nome_do_pai") }}
            </span>
            <v-text-field
              v-model="recurso.nomePai"
              :label="$t('Nome_do_pai')"
              name="nomePai"
              :obrigatorio="isObrigatorio('nomePai')"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="4"
            v-if="isVisivel('nomeMae')"
            data-campo="nomeMae"
            :class="classeCampo('nomeMae')"
          >
            <span class="opacity-5 text-dark" :class="classeRotulo('nomeMae')">
              {{ $t("Nome_da_mae") }}
            </span>
            <v-text-field
              v-model="recurso.nomeMae"
              :label="$t('Nome_da_mae')"
              name="nomeMae"
              :obrigatorio="isObrigatorio('nomeMae')"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="4"
            v-if="isVisivel('nomeConjuge')"
            data-campo="nomeConjuge"
            :class="classeCampo('nomeConjuge')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('nomeConjuge')"
            >
              {{ $t("Nome_conjuge") }}
            </span>
            <v-text-field
              v-model="recurso.nomeConjuge"
              :label="$t('Nome_conjuge')"
              name="nomeConjuge"
              :obrigatorio="isObrigatorio('nomeConjuge')"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-text-field>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
      <v-expansion-panel-header>{{
        $t("Indicadores")
      }}</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-checkbox v-model="recurso.primeiroEmprego">
              <template v-slot:label>
                <div>{{ $t("Primeiro_emprego") }}</div>
              </template>
            </v-checkbox>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-checkbox v-model="recurso.cotaDeficiencia">
              <template v-slot:label>
                <div>{{ $t("Cota_deficiencia") }}</div>
              </template>
            </v-checkbox>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-checkbox v-model="recurso.defFisica">
              <template v-slot:label>
                <div>{{ $t("Deficiencia_fisica") }}</div>
              </template>
            </v-checkbox>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-checkbox v-model="recurso.defVisual">
              <template v-slot:label>
                <div>{{ $t("Deficiencia_visual") }}</div>
              </template>
            </v-checkbox>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-checkbox v-model="recurso.defAuditiva">
              <template v-slot:label>
                <div>{{ $t("Deficiencia_auditiva") }}</div>
              </template>
            </v-checkbox>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-checkbox v-model="recurso.defMental">
              <template v-slot:label>
                <div>{{ $t("Deficiencia_mental") }}</div>
              </template>
            </v-checkbox>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-checkbox v-model="recurso.defIntelectual">
              <template v-slot:label>
                <div>{{ $t("Deficiencia_intelectual") }}</div>
              </template>
            </v-checkbox>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
      <v-expansion-panel-header>
        <span class="secao-cabecalho">
          <span>{{ $t("Dados_bancarios") }}</span>
          <span
            v-if="statusSecoes.Dados_bancarios"
            class="secao-status"
            :class="statusSecoes.Dados_bancarios.classe"
          >
            {{ statusSecoes.Dados_bancarios.texto }}
          </span>
        </span>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-checkbox v-model="recurso.opcaoFGTS">
              <template v-slot:label>
                <div>{{ $t("Fgts_optante") }}</div>
              </template>
            </v-checkbox>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-checkbox v-model="recurso.inssOptante">
              <template v-slot:label>
                <div>{{ $t("Inss_optante") }}</div>
              </template>
            </v-checkbox>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('contaBanco')"
            data-campo="contaBanco"
            :class="classeCampo('contaBanco')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('contaBanco')"
            >
              {{ $t("Banco") }}
            </span>
            <v-text-field
              v-model="recurso.contaBanco"
              :label="$t('Banco')"
              name="contaBanco"
              :obrigatorio="isObrigatorio('contaBanco')"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('contaAgencia')"
            data-campo="contaAgencia"
            :class="classeCampo('contaAgencia')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('contaAgencia')"
            >
              {{ $t("Agencia_numero") }}
            </span>
            <v-text-field
              v-model="recurso.contaAgencia"
              :label="$t('Agencia_numero')"
              name="contaAgencia"
              :obrigatorio="isObrigatorio('contaAgencia')"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('contaNumero')"
            data-campo="contaNumero"
            :class="classeCampo('contaNumero')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('contaNumero')"
            >
              {{ $t("Conta_numero") }}
            </span>
            <v-text-field
              v-model="recurso.contaNumero"
              :label="$t('Conta_numero')"
              name="contaNumero"
              :obrigatorio="isObrigatorio('contaNumero')"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('contaOperacao')"
            data-campo="contaOperacao"
            :class="classeCampo('contaOperacao')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('contaOperacao')"
            >
              {{ $t("Conta_operacao") }}
            </span>
            <v-text-field
              v-model="recurso.contaOperacao"
              :label="$t('Conta_operacao')"
              name="contaOperacao"
              :obrigatorio="isObrigatorio('contaOperacao')"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="6"
            v-if="isVisivel('chavePix')"
            data-campo="chavePix"
            :class="classeCampo('chavePix')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('chavePix')"
            >
              {{ $t("ChavePix") }}
            </span>
            <v-text-field
              v-model="recurso.chavePix"
              :label="$t('ChavePix')"
              :hint="$t('Chave_pix_dica')"
              persistent-hint
              name="chavePix"
              maxlength="77"
              :obrigatorio="isObrigatorio('chavePix')"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-text-field>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel v-show="secaoVisivel('Vencimentos')">
      <v-expansion-panel-header>
        <span class="secao-cabecalho">
          <span>{{ $t("Vencimentos") }}</span>
          <span
            v-if="statusSecoes.Vencimentos"
            class="secao-status"
            :class="statusSecoes.Vencimentos.classe"
          >
            {{ statusSecoes.Vencimentos.texto }}
          </span>
        </span>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('vencimentoSeguancaPessoal')"
            data-campo="vencimentoSeguancaPessoal"
            :class="classeCampo('vencimentoSeguancaPessoal')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('vencimentoSeguancaPessoal')"
            >
              {{ $t("vencimento_seguanca_pessoal") }}
            </span>
            <CampoData
              @date="recurso.vencimentoSeguancaPessoal = $event"
              :payload="recurso.vencimentoSeguancaPessoal"
              label="vencimento_seguanca_pessoal"
              :obrigatorio="isObrigatorio('vencimentoSeguancaPessoal')"
            />
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('vencimentoSegurancaPatrimonial')"
            data-campo="vencimentoSegurancaPatrimonial"
            :class="classeCampo('vencimentoSegurancaPatrimonial')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('vencimentoSegurancaPatrimonial')"
            >
              {{ $t("vencimento_seguranca_patrimonial") }}
            </span>
            <CampoData
              @date="recurso.vencimentoSegurancaPatrimonial = $event"
              :payload="recurso.vencimentoSegurancaPatrimonial"
              label="vencimento_seguranca_patrimonial"
              :obrigatorio="isObrigatorio('vencimentoSegurancaPatrimonial')"
            />
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('vencimentoSegurancaTransporteValores')"
            data-campo="vencimentoSegurancaTransporteValores"
            :class="classeCampo('vencimentoSegurancaTransporteValores')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('vencimentoSegurancaTransporteValores')"
            >
              {{ $t("vencimento_seguranca_transporte_valores") }}
            </span>
            <CampoData
              @date="recurso.vencimentoSegurancaTransporteValores = $event"
              :payload="recurso.vencimentoSegurancaTransporteValores"
              label="vencimento_seguranca_transporte_valores"
              :obrigatorio="
                isObrigatorio('vencimentoSegurancaTransporteValores')
              "
            />
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('vencimentoPscicotecnico')"
            data-campo="vencimentoPscicotecnico"
            :class="classeCampo('vencimentoPscicotecnico')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('vencimentoPscicotecnico')"
            >
              {{ $t("vencimento_pscicotecnico") }}
            </span>
            <CampoData
              @date="recurso.vencimentoPscicotecnico = $event"
              :payload="recurso.vencimentoPscicotecnico"
              label="vencimento_pscicotecnico"
              :obrigatorio="isObrigatorio('vencimentoPscicotecnico')"
            />
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="3"
            v-if="isVisivel('vencimentoToxicologico')"
            data-campo="vencimentoToxicologico"
            :class="classeCampo('vencimentoToxicologico')"
          >
            <span
              class="opacity-5 text-dark"
              :class="classeRotulo('vencimentoToxicologico')"
            >
              {{ $t("vencimento_toxicologico") }}
            </span>
            <CampoData
              @date="recurso.vencimentoToxicologico = $event"
              :payload="recurso.vencimentoToxicologico"
              label="vencimento_toxicologico"
              :obrigatorio="isObrigatorio('vencimentoToxicologico')"
            />
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
      <v-expansion-panel-header>{{
        $t("Dependentes")
      }}</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-col cols="12">
          <CriaSuperSet
            :podeEditarRecursoFinal="true"
            :podeExcluirRecursoFinal="true"
            @recursos="recurso.dependentes = $event"
            :usaRecursoBase="false"
            :payload="recurso.dependentes"
            :pesquisa="false"
            textoBotaoCadastro="Novo_registro"
            tituloFinais="Dependentes"
            subtituloFinais="Clique_para_adicionar"
            :headersFinais="[
              { text: this.$t('Nome'), value: 'nome', sortable: 'true' },
              {
                text: this.$t('Nascimento'),
                value: 'nascimento',
                sortable: 'true',
              },
              { text: this.$t('Tipo'), value: 'tipo', sortable: 'true' },
              { text: this.$t('CPF'), value: 'cpf', sortable: 'true' },
              { text: this.$t('Acoes'), value: 'actions', sortable: 'false' },
            ]"
          >
            <template v-slot:default="slotProps">
              <v-col cols="12" sm="12" md="12">
                <span class="opacity-5 text-dark">
                  {{ $t("Nome") }}
                </span>
                <v-text-field
                  v-model="slotProps.recursoFinalAtual.nome"
                  :label="$t('Nome')"
                  name="nome"
                  type="text"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                >
                </v-text-field>
              </v-col>
              <v-col cols="8" md="8">
                <span class="opacity-5 text-dark">
                  {{ $t("Tipo") }}
                </span>
                <v-select
                  v-model="slotProps.recursoFinalAtual.tipo"
                  :items="itensTipoDependente"
                  :label="$t('Tipo')"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <span class="opacity-5 text-dark">
                  {{ $t("Data_de_nascimento") }}
                </span>
                <CampoData
                  @date="slotProps.recursoFinalAtual.nascimento = $event"
                  :payload="slotProps.recursoFinalAtual.nascimento"
                  label="Data_de_nascimento"
                />
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <span class="opacity-5 text-dark">
                  {{ $t("Sexo") }}
                </span>
                <v-select
                  :items="itensSexo"
                  :label="$t('Sexo')"
                  v-model="slotProps.recursoFinalAtual.sexo"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-select>
              </v-col>
              <v-col cols="4" md="4">
                <span class="opacity-5 text-dark">
                  {{ $t("CPF") }}
                </span>
                <v-text-field
                  v-model="slotProps.recursoFinalAtual.cpf"
                  :label="$t('CPF')"
                  name="cpf"
                  type="text"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                  v-mask="'###.###.###-##'"
                  mask-placeholder="_"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <span class="opacity-5 text-dark">
                  {{ $t("dependenteIrrf") }}
                </span>
                <v-checkbox
                  v-model="slotProps.recursoFinalAtual.dependenteIrrf"
                >
                  <template v-slot:label>
                    {{ $t("dependenteIrrf") }}
                  </template>
                </v-checkbox>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <span class="opacity-5 text-dark">
                  {{ $t("dependenteSalarioFamilia") }}
                </span>
                <v-checkbox
                  v-model="slotProps.recursoFinalAtual.dependenteSalarioFamilia"
                >
                  <template v-slot:label>
                    {{ $t("dependenteSalarioFamilia") }}
                  </template>
                </v-checkbox>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <span class="opacity-5 text-dark">
                  {{ $t("possuiIncapacidadeFisica") }}
                </span>
                <v-checkbox
                  v-model="slotProps.recursoFinalAtual.possuiIncapacidadeFisica"
                >
                  <template v-slot:label>
                    {{ $t("possuiIncapacidadeFisica") }}
                  </template>
                </v-checkbox>
              </v-col>
            </template>
          </CriaSuperSet>
        </v-col>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import CriaSuperSet from "@/components/base/proprios/CriaSuperset.vue";
import ComumDataService from "@/services/ComumDataService";
import {
  GRUPOS_CAMPOS_PREENCHIMENTO,
  campoObrigatorioNoLink,
  campoVazio,
  campoVisivelNoLink,
  situacaoCamposNoLink,
} from "./camposPreContratacao";

// Posição de cada grupo de campos nos painéis do formulário.
const PAINEL_GRUPO = {
  Identificacao: 0,
  Endereco: 1,
  Documentos: 2,
  Dados_familiares: 3,
  Dados_bancarios: 5,
  Vencimentos: 6,
};

export default {
  name: "FormularioFuncionarioPreContratracao",
  components: { CriaSuperSet },
  props: {
    recurso: { type: Object, required: true },
    cidades: { type: Array, default: () => [] },
    estados: { type: Array, default: () => [] },
    obrigatorio: { type: Boolean, default: false },
    // Campos exibidos e obrigatórios do link público; sem configuração, valem todos.
    configuracaoCampos: { type: Object, default: null },
    // Depois da primeira tentativa de envio, destaca os obrigatórios vazios.
    destacarPendentes: { type: Boolean, default: false },
  },
  data() {
    return {
      panelsAbertos: [0, 1, 2, 3, 4, 5, 6, 7, 8],
      loadingCep: false,
      itensInstrucao: [
        { text: this.$t("Analfabeto"), value: "ANALFABETO" },
        {
          text: this.$t("Quinto_ano_incompleto"),
          value: "QUINTOANOINCOMPLETO",
        },
        { text: this.$t("Quinto_ano_completo"), value: "QUINTOANOCOMPLETO" },
        {
          text: this.$t("Fundamental_incompleto"),
          value: "FUNDAMENTALINCOMPLETO",
        },
        { text: this.$t("Fundamental_completo"), value: "FUNDAMENTALCOMPLETO" },
        {
          text: this.$t("Ensino_medio_incompleto"),
          value: "ENSMEDIOINCOMPLETO",
        },
        {
          text: this.$t("Ensino_medio_completo"),
          value: "ENSMEDIOCOMPLETO",
        },
        {
          text: this.$t("Ensino_superior_incompleto"),
          value: "SUPERIORINCOMPLETO",
        },
        {
          text: this.$t("Ensino_superior_completo"),
          value: "SUPERIORCOMPLETO",
        },
        { text: this.$t("Pos_graduado"), value: "POSGRADUADO" },
        { text: this.$t("Mestrado"), value: "MESTRADO" },
        { text: this.$t("Doutorado"), value: "DOUTORADO" },
      ],
      itensRaca: [
        { text: this.$t("Branca"), value: "BRANCA" },
        { text: this.$t("Preta"), value: "PRETA" },
        { text: this.$t("Parda"), value: "PARDA" },
        { text: this.$t("Amarela"), value: "AMARELA" },
        { text: this.$t("Indigena"), value: "INDIGENA" },
      ],
      itensSexo: [
        { text: this.$t("Masculino"), value: "MASCULINO" },
        { text: this.$t("Feminino"), value: "FEMININO" },
      ],
      itensEstadoCivil: [
        { text: this.$t("Solteiro"), value: "SOLTEIRO" },
        { text: this.$t("Casado"), value: "CASADO" },
        { text: this.$t("Divorciado"), value: "DIVORCIADO" },
        { text: this.$t("Separado"), value: "SEPARADO" },
        { text: this.$t("Viuvo"), value: "VIUVO" },
        { text: this.$t("Comcubinado"), value: "COMCUBINADO" },
        { text: this.$t("UniaoEstavel"), value: "UNIAOESTAVEL" },
      ],
      itensGrupoSanguineo: [
        { text: this.$t("APOSITIVO"), value: "APOSITIVO" },
        { text: this.$t("ANEGATIVO"), value: "ANEGATIVO" },
        { text: this.$t("BPOSITIVO"), value: "BPOSITIVO" },
        { text: this.$t("BNEGATIVO"), value: "BNEGATIVO" },
        { text: this.$t("ABPOSITIVO"), value: "ABPOSITIVO" },
        { text: this.$t("ABNEGATIVO"), value: "ABNEGATIVO" },
        { text: this.$t("OPOSITIVO"), value: "OPOSITIVO" },
        { text: this.$t("ONEGATIVO"), value: "ONEGATIVO" },
      ],
      itensCnhCategoria: [
        { text: "A", value: "CNHA" },
        { text: "B", value: "CNHB" },
        { text: "C", value: "CNHC" },
        { text: "D", value: "CNHD" },
        { text: "E", value: "CNHE" },
        { text: "AB", value: "CNHAB" },
        { text: "AC", value: "CNHAC" },
        { text: "AD", value: "CNHAD" },
        { text: "AE", value: "CNHAE" },
      ],
      itensTipoDependente: [
        { text: this.$t("CONJUGUE"), value: "CONJUGUE" },
        {
          text: this.$t("COMPANHEIROUNIAOESTAVEL"),
          value: "COMPANHEIROUNIAOESTAVEL",
        },
        { text: this.$t("FILHOENTEADO"), value: "FILHOENTEADO" },
        {
          text: this.$t("IRMAONETOBISNETOSEMARRIMO"),
          value: "IRMAONETOBISNETOSEMARRIMO",
        },
        { text: this.$t("PAISAVOSBISAVOS"), value: "PAISAVOSBISAVOS" },
        { text: this.$t("MENORGUARDAJUDICIAL"), value: "MENORGUARDAJUDICIAL" },
        { text: this.$t("PESSOAINCAPAZ"), value: "PESSOAINCAPAZ" },
        { text: this.$t("EXCONJUGUE"), value: "EXCONJUGUE" },
        { text: this.$t("AGREGADOOUTROS"), value: "AGREGADOOUTROS" },
      ],
    };
  },
  computed: {
    // Pendências por seção, mostradas no cabeçalho dos painéis do link público.
    statusSecoes() {
      if (!this.obrigatorio) {
        return {};
      }
      const situacao = situacaoCamposNoLink(
        this.configuracaoCampos,
        this.recurso
      );
      return GRUPOS_CAMPOS_PREENCHIMENTO.reduce((status, grupo) => {
        const campos = situacao.filter((item) => item.grupo === grupo.titulo);
        if (!campos.length) {
          return status;
        }
        const pendentes = campos.filter((item) => item.pendente).length;
        status[grupo.titulo] = pendentes
          ? {
              classe: "secao-status--pendente",
              texto: this.$tc("Pre_contratacao_secao_pendentes", pendentes, {
                quantidade: pendentes,
              }),
            }
          : {
              classe: "secao-status--completa",
              texto: this.$t("Pre_contratacao_secao_completa"),
            };
        return status;
      }, {});
    },
    mensagemCampoPendente() {
      return JSON.stringify(this.$t("Campo_obrigatorio"));
    },
  },
  methods: {
    classeRotulo(campo) {
      return { "campo-obrigatorio-label": this.isObrigatorio(campo) };
    },
    classeCampo(campo) {
      return {
        "campo-pendente":
          this.destacarPendentes &&
          this.isObrigatorio(campo) &&
          campoVazio(this.recurso[campo]),
      };
    },
    // Abre o painel do campo, rola até ele e põe o foco no texto (selects abririam o menu).
    irParaCampo(campo) {
      const grupo = GRUPOS_CAMPOS_PREENCHIMENTO.find((item) =>
        item.campos.some((c) => c.campo === campo)
      );
      const painel = grupo ? PAINEL_GRUPO[grupo.titulo] : undefined;
      if (painel !== undefined && !this.panelsAbertos.includes(painel)) {
        this.panelsAbertos = [...this.panelsAbertos, painel];
      }
      setTimeout(() => {
        const el =
          this.$el && this.$el.querySelector(`[data-campo="${campo}"]`);
        if (!el) {
          return;
        }
        el.scrollIntoView({ behavior: "smooth", block: "center" });
        const input = el.querySelector("input:not([type='hidden'])");
        if (input && !input.readOnly) {
          input.focus({ preventScroll: true });
        }
      }, 350);
    },
    isObrigatorio(campo) {
      return (
        this.obrigatorio &&
        campoObrigatorioNoLink(this.configuracaoCampos, campo)
      );
    },
    // A configuração só oculta campos no link público; na edição interna aparecem todos.
    isVisivel(campo) {
      return (
        !this.obrigatorio || campoVisivelNoLink(this.configuracaoCampos, campo)
      );
    },
    secaoVisivel(titulo) {
      const grupo = GRUPOS_CAMPOS_PREENCHIMENTO.find(
        (item) => item.titulo === titulo
      );
      return !grupo || grupo.campos.some(({ campo }) => this.isVisivel(campo));
    },
    async buscaCep() {
      if (!this.recurso || !this.recurso.cep) {
        return;
      }
      const cep = String(this.recurso.cep).replace(/\D/g, "");
      if (cep.length < 8) {
        return;
      }
      this.loadingCep = true;
      try {
        const response = await ComumDataService.buscaCep(cep);
        const data = (response && response.data) || {};
        if (data.logradouro) {
          this.recurso.logradouro = data.logradouro;
        }
        if (data.bairro) {
          this.recurso.bairro = data.bairro;
        }
        if (data.uf) {
          this.recurso.uf = data.uf;
        }
        if (data.localidade && data.uf) {
          const cidade = await ComumDataService.findCidade({
            cidade: data.localidade,
            uf: data.uf,
          });
          if (cidade && cidade.data) {
            this.recurso.cidade = cidade.data;
          }
        }
        // Endereço encontrado: o próximo dado a digitar é o número.
        if (data.logradouro && !this.recurso.numero) {
          this.$nextTick(() => {
            const numero =
              this.$el && this.$el.querySelector('[data-campo="numero"] input');
            if (numero) {
              numero.focus();
            }
          });
        }
      } catch (error) {
        // Silencia falhas de CEP para nao bloquear o preenchimento manual.
      } finally {
        this.loadingCep = false;
      }
    },
    handleCidadeChange(value) {
      if (value && value.estado && value.estado.sigla) {
        this.recurso.uf = value.estado.sigla;
      }
    },
  },
};
</script>

<style scoped>
/* Rótulo do obrigatório mais forte que o do opcional (opacity-5), com o asterisco visível. */
.campo-obrigatorio-label {
  opacity: 0.8 !important;
}

.campo-obrigatorio-label::after {
  color: #e53935;
  content: " *";
  font-weight: 700;
}

/* No link público, a área de mensagens vazia não separa os campos (os de data já não a reservam). */
.formulario-pre-contratacao--publico
  ::v-deep
  .v-text-field__details:not(:has(.v-messages__message)) {
  display: none;
}

.formulario-pre-contratacao--publico ::v-deep .v-input {
  margin-bottom: 4px;
}

.formulario-pre-contratacao--publico ::v-deep .v-input--selection-controls {
  margin-top: 0;
}

.formulario-pre-contratacao--publico
  ::v-deep
  .v-input--selection-controls
  .v-messages:not(:has(.v-messages__message)) {
  display: none;
}

.campo-pendente ::v-deep .v-input__slot {
  box-shadow: 0 0 0 1px #e53935 !important;
}

/* A mensagem fica no lugar da área de detalhes vazia; o CampoData mostra a própria validação. */
.campo-pendente ::v-deep .v-text-field__details {
  display: none;
}

.campo-pendente::after {
  color: #e53935;
  content: var(--mensagem-campo-pendente);
  display: block;
  font-size: 0.75rem;
  margin: 4px 0 6px 2px;
}

.campo-pendente:has(.v-messages__message) ::v-deep .v-text-field__details {
  display: flex;
}

.campo-pendente:has(.v-messages__message)::after {
  display: none;
}

.secao-cabecalho {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 6px 10px;
}

.secao-status {
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.6;
  padding: 0 8px;
}

.secao-status--pendente {
  background: #fffaeb;
  color: #b54708;
}

.secao-status--completa {
  background: #ecfdf3;
  color: #027a48;
}

@media (max-width: 599px) {
  .formulario-pre-contratacao ::v-deep .v-expansion-panel-content__wrap {
    padding: 0 12px 12px;
  }

  .formulario-pre-contratacao ::v-deep .v-expansion-panel-header {
    padding: 12px;
  }
}
</style>
